import React, * as r from 'react';
import { createContainer } from "unstated-next"
import { Post, Taxonomy, Notice } from './../../types/index'
import { useRest } from './../../services/api/useRest/rest'
import moment from 'moment-timezone'


const useStore = () => {
  const [originalPosts, setOriginalPosts] = r.useState([] as Post[])
  const [posts, setPosts] = r.useState([] as Post[])
  const [taxonomies, setTaxonomies] = r.useState([] as Taxonomy[])
  const [keyword, setKeyword] = r.useState("")
  const [selectTermTaxonomyIds, setSelectTermTaxonomyIds] = r.useState([] as number[])
  const [selectDiscountId, setSelectDiscountId] = r.useState("" as "" | "all" | "under25" | "50" | "75" | "over76")
  const [notices, setNotices] = r.useState([] as Notice[])
  const [currentPage, setCurrentPage] = r.useState(1)
  const [endTime, setEndTime] = r.useState("")


  const { mainFetch } = useRest()

  /** タグは一度取得したら2回目は呼ばない想定なので初期化を行う。 */

  /** タグ検索 */
  r.useEffect(() => {
    setPostsFilter(originalPosts)
    setCurrentPage(1)
  }, [selectTermTaxonomyIds, selectDiscountId])

  /** タグチェック */
  const changeSelectTermTaxonomyIds = (checkSelectTermTaxonomyId: number) => {
    if (selectTermTaxonomyIds.includes(checkSelectTermTaxonomyId)) {
      setSelectTermTaxonomyIds(selectTermTaxonomyIds.filter(id => id !== checkSelectTermTaxonomyId))
    } else {
      setSelectTermTaxonomyIds(prev => [...prev, checkSelectTermTaxonomyId])
    }
  }

  /** 検索全削除 */
  const selectAllRemove = () => {
    setKeyword("")
    setSelectTermTaxonomyIds([] as number[])
    setSelectDiscountId("")
  }

  /** post設定フィルター */
  const setPostsFilter = (posts: Post[]) => {
    const termTaxonomyFilterPosts = selectTermTaxonomyIds.length ? filterTaxonomyIdsPosts(posts) : posts
    const allFilterPosts = selectDiscountId.length ? filterDiscountPosts(termTaxonomyFilterPosts) : termTaxonomyFilterPosts
    setPosts(allFilterPosts)
  }
  /* タクソノミーフィルター */
  const filterTaxonomyIdsPosts = (posts: Post[]) =>
    posts.filter(post => {
      const ids = post.taxonomies.map(postTaxonomy => postTaxonomy.term_taxonomy_id)
      const checkIds = selectTermTaxonomyIds.filter(selectId => ids.includes(selectId))
      return checkIds.length === selectTermTaxonomyIds.length
    })

  /**割引フィルター */
  const filterDiscountPosts = (posts: Post[]) =>
    posts.filter(post => {
      if (!selectDiscountId) return true

      const discountTypes = {
        "all": {
          min: 0,
          max: 100
        },
        "under25": {
          min: 0,
          max: 25
        },
        "50": {
          min: 25,
          max: 50
        },
        "75": {
          min: 50,
          max: 75

        },
        "over76": {
          min: 75,
          max: 100
        },
      }
      const { min, max } = discountTypes[selectDiscountId]
      const isDisDlsite = post.dlsite_rate && (min < Number(post.dlsite_rate) && Number(post.dlsite_rate) < max)
      const isDisDmm = post.dmm_rate && (min < Number(post.dmm_rate) && Number(post.dmm_rate) < max)
      return isDisDlsite || isDisDmm
    })

  /* 記事取得 */
  const ArticleReload = async () => {
    console.log("ArticleReload")
    try {
      const data = await mainFetch<{
        endTIme: string,
        reviews: Post[]
      }>(
        process.env.REACT_APP_URL + `api/wp/reviews?keyword=${keyword}`, {
        method: "GET",
      })
      setEndTime(data["endTime"])

      setOriginalPosts(data["reviews"].sort((b, a) => moment(a.post_date).diff(b.post_date)))
      setPostsFilter(data["reviews"])
      setCurrentPage(1)
    } catch (e) {
      alert("記事の取得に失敗しました。もう一度画面を読み込んでください")
      return
    }
  }

  /* タクソノミー取得 */
  const TaxonomyReload = async () => {
    console.log("TaxonomyReload")

    try {
      const data = await mainFetch<Taxonomy[]>(
        process.env.REACT_APP_URL + "api/wp/review-categories", {
        method: "GET"
      })
      setTaxonomies(data)
    } catch {
      alert("カテゴリーの取得に失敗しました。もう一度画面を読み込んでください")
      return
    }
  }

  /* Notices取得 */
  const NoticeReload = async () => {
    console.log("NoticeReload")

    try {
      const data = await mainFetch<Notice[]>(
        process.env.REACT_APP_URL + "api/notices", {
        method: "GET"
      })
      setNotices((data.sort((a, b) => moment(b.created_at).diff(a.created_at))))
    } catch {
      alert("お知らせの取得に失敗しました。もう一度画面を読み込んでください")
      return
    }
  }

  /** 表示する分のポストを返す。 カラムは1列、もしくは2列。ユーザーのWebサイズを元に返す*/
  const slice = (
    posts: Post[],
    nextPage: number,
    showPosts = 10,
  ) => {
    const startIndex = (nextPage - 1) * showPosts
    return posts.slice(startIndex, startIndex + showPosts)
    /**以下は配列自体を分ける方法。2列用に使う想定だったが必要ないのでコメントアウト。どこかで使うかもなので一応残しておく */
    // const slicePosts = posts.slice(startIndex, startIndex + showPosts > posts.length ? startIndex + showPosts : showPosts)
    // const length = Math.ceil(slicePosts.length / showColumn)
    // return [...Array(length)].map((_, i) => slicePosts.slice(i * showColumn, (i + 1) * showColumn))
  }

  const [isDummy] = r.useState("" as "" | "AllDummy" | "CategoryDummy" | "PostDummy")


  /* タクソノミー取得 */
  const getTaxonomy = async (termTaxonomyId: number) => {
    const termName = taxonomies.find(taxonomy => taxonomy.term_taxonomy_id === termTaxonomyId)
    return termName || "other"
  }

  return {
    posts,
    taxonomies,
    isDummy,
    slice,
    keyword,
    setKeyword,
    selectTermTaxonomyIds,
    changeSelectTermTaxonomyIds,
    selectAllRemove,
    notices,
    ArticleReload,
    TaxonomyReload,
    NoticeReload,
    selectDiscountId,
    setSelectDiscountId,
    currentPage,
    setCurrentPage,
    endTime,
    getTaxonomy
  }
}

const Stores = createContainer(useStore)
export { Stores }